<template>
    <div class="app--container">
        <header class="header">
            <div class="header--logo-container">
                <a href="http://www.fwa.eu/" title="Aller sur fwa.eu"><img src="/telechargement/content/fwa.png" alt="FWA développeurs d'idées."></a>
            </div>
            <div class="header--title">
                <img src="/telechargement/content/logo.svg" alt="">
                <h1>{{ $t('home') }}</h1>
            </div>
            <nav aria-label="Choose language" class="nav--lang">
                <a title="Version française" @click="setLanguage('fr')"><img src="/telechargement/content/fr-flag.svg" alt=""><span class="sr-only">Version française</span></a>
                <a title="English version" @click="setLanguage('en')"><img src="/telechargement/content/en-flag.svg" alt=""><span class="sr-only">English version</span></a>
            </nav>
        </header>

        <loadingPanel></loadingPanel>

        <main class="main--container" v-if="dataInitialized">
            <!--<div class="breadcrumb">
            <breadCrumbs></breadCrumbs>
        </div>-->
            <div class="router-view-content">
                <router-view></router-view>
            </div>
        </main>

        <footer class="footer">
            <p>
                {{ $t('footerMessage1') }}<a href="tel:+33175602900">+33 1 75 60 29 00</a> {{ $t('footerMessage2') }} <a href="mailto:contact@fwa.eu">contact@fwa.eu</a>
            </p>
        </footer>
    </div>
</template>
<script>
    import breadCrumbs from '@/Common/Components/breadcrumbs.vue';
    import loadingPanel from '@/Common/Components/loading-panel.vue';
    import { LoadingMethods } from '@/Common/Mixins/loading-panel-communication';
    import { locale, loadMessages } from 'devextreme/localization';
    import frMessages from 'devextreme/localization/messages/fr.json';
    import customFrMessages from '@/Common/Resource/dx.custom.messages.fr.js';
    import 'devextreme/dist/css/dx.common.css';
    import 'devextreme/dist/css/dx.light.css';
    
    export default {
        mixins: [
            LoadingMethods
        ],
        components: {
            breadCrumbs,
            loadingPanel
        },
        data() {
            return {
                dataInitialized: false,
                locale: 'fr'
            }
        },
        methods: {
            load() {
                loadMessages(frMessages);
                loadMessages(customFrMessages);
                this.dataInitialized = true;
                if (localStorage.getItem('locale') === 'undefined' || localStorage.getItem('locale') === null) {
                    localStorage.locale = 'fr';
                }

                this.locale = localStorage.locale;
                locale(localStorage.locale);
            },
            setLanguage(language) {
                this.locale = language;
                location.reload(true);
            },
        },
        watch: {
            locale(newLocale) {
                this.locale = newLocale;
                this.$i18n.locale = this.locale;
                localStorage.locale = this.locale
                locale(newLocale);
            }
        },
        created() {
            this.load();
        },
        mounted() {
            this.showLoadingPanel();
        }
    }
</script>

<style scoped>
    .breadcrumb {
        background-color: #35495E;
        color: white;
        height: 55px;
        line-height: 50px;
        padding-left: 10px;
    }

    .router-view-content {
        padding: 10px;
    }

</style>

<i18n>
    {
        "fr": {
            "home": "Service de téléchargement de fichiers",
            "footerMessage1": "Pour personnaliser ce service aux couleurs de votre entreprise, contactez-nous au ",
            "footerMessage2": "ou par courriel : "
        },
        "en": {
            "home": "Files download service",
            "footerMessage1": "To customize the service to your company colors, contact us at ",
            "footerMessage2": "or email: "
        }
    }
</i18n>